import { useTranslation } from '@/hooks/useTranslation'
import config from '../../../config'

export function AuthLegalNotice({ className = '' }: { className?: string }) {
	const { t } = useTranslation()

	return (
		<p className={`text-xs text-gray-500 leading-relaxed ${className}`}>
			{t('auth.legalAgreementStart')}{' '}
			<a
				href={config.termsAndConditionsUrl}
				className="font-medium text-primary hover:text-primary/90"
			>
				{t('auth.legalTermsLink')}
			</a>{' '}
			{t('auth.legalAnd')}{' '}
			<a
				href={config.privacyPolicyUrl}
				className="font-medium text-primary hover:text-primary/90"
			>
				{t('auth.legalPrivacyLink')}
			</a>
			.
		</p>
	)
}
